import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar.jsx";
import Banner from "../Section/Banner/banner";
import About from "../Section/About/about1.jsx";
import BannerLeyora from "../Section/BannerLeyora/BannerLeyora.jsx";
import Leyora from "../Section/Leyora/Leyora.jsx";
import New from "../Section/New/New.jsx";
import Orlens from "../Section/Orleans/Orleans.jsx";

import Produk from "../Section/Produk/Produk.jsx";
import Ruko from "../Section/Ruko/Ruko.jsx";
import Surrounding from "../Section/Surrounding/Surrounding.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footerup/footerup.jsx";
import Scrolltohashelement from "../Pages/ScrollToHashElement";
import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281325283186&text=Halo%20Reza,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Wisata%20https://perumahankotawisata.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <BannerLeyora />
      <Leyora />
      <New />
      <Orlens />
      <Produk />
      <Ruko />
      <Surrounding />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
